import { render, staticRenderFns } from "./Activetwilio.vue?vue&type=template&id=14323647&"
import script from "./Activetwilio.vue?vue&type=script&lang=js&"
export * from "./Activetwilio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports